import * as http from "utils/http";

export async function t(key: string, params: object = {}) {
  const response = await http.httpGet("/frontend/translation", { key, ...params });
  return await response.text();
}

export interface Plural {
  one: string;
  other: string;
}

export function pluralize(i18n: Plural, count: number) {
  return count == 1 ? i18n.one : i18n.other.replace("%{count}", count.toString());
}
